import { useState } from "react";
import { useBreakpoint } from "../ui/Grid";

const STORED_TRUE = "true";

function readStored(storageKeys: readonly string[]): boolean {
  for (const key of storageKeys) {
    try {
      const stored = localStorage.getItem(key);
      if (stored !== null) return stored === STORED_TRUE;
    } catch {
      return false;
    }
  }
  return false;
}

/**
 * Eingeklappter Zustand der Navigation für `AppShell`, ein Verhalten für alle Produkte. Ab `lg` (992 px) gilt der im
 * Browser gespeicherte Zustand; `storageKeys` nennt die Schlüssel in Lesereihenfolge, geschrieben wird der erste.
 * Darunter startet die Navigation eingeklappt; eine Umschaltung gilt dort, bis sich Breitenklasse oder Schlüssel
 * ändern, und überschreibt den gespeicherten Zustand nicht.
 */
export function useAppShellNavigationCollapsed(storageKeys: readonly string[]): readonly [boolean, (collapsed: boolean) => void] {
  const narrow = useBreakpoint().lg === false;
  const scope = `${narrow ? "narrow" : "wide"}|${storageKeys.join("|")}`;
  const [override, setOverride] = useState<{ scope: string; value: boolean } | null>(null);
  const collapsed = override?.scope === scope ? override.value : narrow || readStored(storageKeys);
  const setCollapsed = (next: boolean) => {
    if (!narrow && storageKeys[0]) {
      try {
        localStorage.setItem(storageKeys[0], String(next));
      } catch {
        // Ohne Browserspeicher gilt die Umschaltung bis zum Neuladen.
      }
    }
    setOverride({ scope, value: next });
  };
  return [collapsed, setCollapsed] as const;
}
